import { observer } from 'mobx-react-lite';
import { Moon, Sun } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_ThemeStore } from './ThemeStore';

export const ThemeToggleView = observer(function ThemeToggleView() {
  const store = useResolve(TOKEN_ThemeStore);
  return (
    <button
      type="button"
      onClick={store.toggle}
      aria-label="Toggle theme"
      title="Toggle theme (d)"
      className="flex h-8 w-8 items-center justify-center border border-steel-300 bg-white text-steel-700 hover:border-amber-signal hover:text-amber-signal dark:border-steel-700 dark:bg-steel-900 dark:text-steel-300"
    >
      {store.isDark ? <Sun weight="fill" size={16} /> : <Moon weight="fill" size={16} />}
    </button>
  );
});
